import classNames from 'classnames';
import { DynamicComponent } from 'yoso';
import { currencySymbol, useCurrency } from '~/components/Currency/Currency.hooks';
import styles from './Currency.module.scss';

export type Props = {
  className?: string;
  value?: number;
  reversed?: boolean;
} & Intl.NumberFormatOptions;

export type CurrencyProps = DynamicComponent<Props, JSX.IntrinsicElements['span']>;
export const Currency = ({ value = 0, reversed, className, ...options }: CurrencyProps) => {
  const { currency, formatted } = useCurrency(value, options);
  const isFiat = Object.keys(currencySymbol).includes(currency);
  const safeReversed = isFiat ? !reversed : reversed;
  const safeCurrency = isFiat ? currencySymbol[currency] : currency;
  return (
    <span className={classNames(styles.root, { [styles.fiat]: isFiat }, className)}>
      {safeReversed && <span className={styles.currency}>{safeCurrency}</span>}
      <span className={styles.value}>{formatted}</span>
      {!safeReversed && <span className={styles.currency}>{safeCurrency}</span>}
    </span>
  );
};
